import { useState, useEffect } from "react";
import useEventStore from "../stores/EventStore";
import './EventDate.css';

export default function DateVoting() {
  const [role, setRole] = useState(null);
  const { dateToVote, updateDateToVote, voteCountsPerDate,
    getDateVoteCounts, saveDateVotes, eventInformation, setFinalEventDate } = useEventStore(); // z.B. [{ eventDateId, voteDate }]

  const handleVote = (eventDateId, voteDate, voteValue) => {
    updateDateToVote(eventDateId, voteDate, voteValue);
  };


  useEffect(() => {
    const userRole = localStorage.getItem("role");
    setRole(userRole || "");
  }, []);

  const submitVotes = async () => {
    //backend call
    const name = localStorage.getItem('username');
    saveDateVotes(name);
  }

  const setFinalDate = async (event_date_id) => {
    const isConfirmed = window.confirm("Nach dem Bestätigen ist es Datum final, kein zurück!");

    if (isConfirmed) {
      // If the user confirms, proceed with setting the final date
      setFinalEventDate(event_date_id);
    } else {
      // If the user cancels, you can do nothing or show a message
      console.log("Action cancelled.");
    }
  }


  if (!dateToVote || dateToVote.length === 0) {
    return <div></div>;
  }

  if (eventInformation.headline === null || eventInformation.headline === "") {
    return <div>Es finden zurzeit keine Events statt</div>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto">
        <thead>
          <tr>
            <th>Datum</th>
            <th>Da kann ich</th>
            <th>Da nicht</th>
            {role === "ADMIN" && (
              <th>nur admin</th>
            )}
          </tr>
        </thead>
        <tbody>
          {dateToVote.map(({ eventDateId, voteDate, voteValue }) => (
            <tr key={eventDateId}>
              <td>{voteDate}</td>
              <td>
                <div className="vote-cell-vertical">
                  <button
                    onClick={() => handleVote(eventDateId, voteDate, 1)}
                    className={voteValue === 1 ? 'selected' : ''}
                  >
                    <span className="yes-symbol">✔</span>
                  </button>
                  <div className="vote-info">
                    <i className="fas fa-user"
                      style={{
                        color: 'green',
                        marginTop: '-10px',
                        marginLeft: '11px'
                      }}></i>
                    <p style={{
                      marginTop: '5px',
                      marginLeft: '4px'
                    }}>
                      {
                        voteCountsPerDate
                          .find(v => v.eventDateId === eventDateId && v.voteValue === 1)
                          ?.voteCount || 0
                      }
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <div className="vote-cell-vertical">
                  <button
                    onClick={() => handleVote(eventDateId, voteDate, 0)}
                    className={voteValue === 0 ? 'selected' : ''}
                  >
                    <span className="no-symbol">✖</span>
                  </button>
                  <div className="vote-info">
                    <i className="fas fa-user"
                      style={{
                        color: 'red',
                        marginTop: '-10px',
                        marginLeft: '11px'
                      }}></i>
                    <p style={{
                      marginTop: '5px',
                      marginLeft: '4px'
                    }}>
                      {
                        voteCountsPerDate
                          .find(v => v.eventDateId === eventDateId && v.voteValue === 0)
                          ?.voteCount || 0
                      }
                    </p>
                  </div>
                </div>
              </td>
              {role === "ADMIN" && (
                <td>
                  <button
                    onClick={() => setFinalDate(eventDateId)}>
                    Finales Datum für das Event</button>
                </td>
              )}
            </tr>
          ))}
        </tbody>

      </table>
      <button onClick={() => submitVotes()}>Änderungen speichern</button>
    </div>
  );
}
